import { render } from "./verify-account.vue?vue&type=template&id=d6cc3168&scoped=true"
import script from "./verify-account.vue?vue&type=script&lang=js"
export * from "./verify-account.vue?vue&type=script&lang=js"

import "./verify-account.vue?vue&type=style&index=0&id=d6cc3168&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6cc3168"]])

export default __exports__